export default __webpack_public_path__ + "static/media/hint_text.5f8510a8.png";